import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceL } from '@xing-com/tokens';

const PreviewContainer = styled.div`
  padding: 0 ${spaceL};

  @media ${mediaSmallOrTiny} {
    padding: 0;
  }
`;

export const Styled = { PreviewContainer };
